import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
// import { useSelector } from 'react-redux';
import { isMobile } from 'react-device-detect';
import { Grid, Tab } from 'semantic-ui-react';

import { find } from '../../../utils/lodash';
import { APP_NAME, ADMIN_FEATURES } from '../../../utils/constant';
import { CustomSegment } from '../../../components';
// import { exportSystemUsers } from '../../../store/actions';

import { Features, PermissionGroups } from './forms';

import '../admin.scss';

const SystemFeatures = ({ match, exportSystemUsers, usersCsvLink }) => {
  const { t } = useTranslation();
  const [currentTab, setCurrentTab] = useState(0);
  const navigate = useNavigate();

  // const dispatch = useDispatch();
  // const auth = useSelector(state => state.authentication);
  // const user = useSelector(state => state.authentication.user);
  // const helpTips = useSelector(state => state.extra.activityHelpTips);

  useEffect(() => {
    try {
      if (match.params.type) {
        changeRoute(match.params.type);
      }
    } catch (error) {
      console.error(error);
    }
  }, [match.params.type]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    document.title = `${t('common.features')} | ${APP_NAME}`;
  }, [t]);

  const generateTabs = () => {
    const panes = [
      {
        menuItem: t('common.features'),
        render: () => (
          <Tab.Pane attached={false} className="custom-tab">
            <CustomSegment
              title={t('common.features')}
              children={<Features />}
            />
          </Tab.Pane>
        ),
      },
      {
        menuItem: t('common.permission_groups'),
        render: () => (
          <Tab.Pane attached={false} className="custom-tab">
            <CustomSegment
              title={t('common.permission_groups')}
              children={<PermissionGroups />}
            />
          </Tab.Pane>
        ),
      },
    ];

    return panes;
  };

  const onTabClick = (data) => {
    changeRoute(data.activeIndex);
  };

  // const onClickUsersExport = async () => {
  //   await exportSystemUsers();
  //   if (!isEmpty(usersCsvLink)) {
  //     window.open(usersCsvLink.download_link, '_blank');
  //   }
  // };

  const changeRoute = async (value) => {
    try {
      const tab = await find(ADMIN_FEATURES(t), (o) => {
        return o.id === value || o.route === value;
      });
      setCurrentTab(tab.id);
      navigate(`/admin/system-features/${tab.route}`);
    } catch (error) {
      console.error(error);
      return false;
    }
  };

  return (
    <Grid.Row>
      <Tab
        menu={{ borderless: true, attached: false, tabular: false }}
        panes={generateTabs()}
        className={isMobile ? 'custom-tabs-mobile' : 'custom-tabs'}
        activeIndex={currentTab}
        onTabChange={(e, data) => onTabClick(data)}
      />
    </Grid.Row>
  );
};

export default SystemFeatures;
